import { Box, Container, Typography } from '@mui/material';
import BatchEditVersionDatesDialog from '../../../components/BatchEditVersionDatesDialog/BatchEditVersionDatesDialog';
import BatchEditVersionNameDialog from '../../../components/BatchEditVersionNameDialog/BatchEditVersionNameDialog';
import CampaignVersionsDialog from '../../../components/CampaignVersionsDialog/CampaignVersionsDialog';
import TutorialVideoButton from '../../../components/TutorialVideosModal/TutorialVideoButton';
import { $$tutorialVideos } from '../../../components/TutorialVideosModal/model';
import CampaignTableFilters from './CampaignTableFilters';
import CampaignsTable from './CampaignsTable';
import { useUnit } from 'effector-react';
import { $$theme } from '../../../services/ThemeService/model';
import { $$personaService } from '../../../services/PersonaService/model.js';

/**
 * Component for displaying the form to manage campaigns.
 *
 * @returns {React.ReactNode} AdminCampaigns component
 */
export default function AdminCampaignsPage() {
  const { palette } = useUnit($$theme.$palette);
  const isMapPersona = useUnit($$personaService.$isMapActivePersona);

  return (
    <>
      <CampaignVersionsDialog />
      <BatchEditVersionNameDialog />
      <BatchEditVersionDatesDialog />
      <TutorialVideoButton url={$$tutorialVideos.links[isMapPersona ? 'MT:EDIT_CAMPAIGNS_VERSIONS' : 'ST_ADMIN:EDIT_CAMPAIGNS_VERSIONS']} />

      <Container id="admin-campaigns-container">
        <Typography variant="h4" color="text.primary" sx={{ mb: isMapPersona ? 1 : 6 }}>
          Edit Campaigns
        </Typography>
        {isMapPersona && (
          <Box sx={{ display: 'flex', alignItems: 'center', pb: 1.5, mb: 3 }}>
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 0 }}>
              <span style={{ color: palette.error.main }}>*</span> Indicates a required field
            </Typography>
          </Box>
        )}
        <CampaignTableFilters />
        <CampaignsTable />
      </Container>
    </>
  );
}

AdminCampaignsPage.propTypes = {};
